import { FILTER_ICON_MAP } from '@root/lib/constants';
import Image from '@root/lib/components/Image';
import './VariantCard.scss';

/**
 * @param {{
 *   title: string;
 *   product: {
 *     title: string;
 *     tags: Array<string>
 *   };
 *   quantity: number;
 *   price: number;
 *   image: {
 *     src: string;
 *     alt: string;
 *   };
 * }} props 
 */
const VariantCard = ({
  title,
  product,
  quantity,
  image,
}) => {
  return (
    <div className="VariantCard">
      <picture className="VariantCard__ImageContainer">
        <Image src={image.src} alt={image.alt || `${product.title} - ${title}`} ratio="1:1" />
      </picture>
      <div className="VariantCard__Details">
        <h2 className="VariantCard__ProductTitle">{product.title}</h2>
        {!title.includes('Default') && (
          <div className="VariantCard__VariantTitle">
            <span>{title}</span>
          </div>
        )}
        <div className="VariantCard__Quantity">
          Qty {quantity}
        </div>
        <div className="VariantCard__Icons">
          {product.tags.map(t => FILTER_ICON_MAP.get(t)).filter(v => v !== undefined).map(icon =>
            <icon.svg title={icon.alt} key={icon.alt} />
          )}
        </div>
      </div>
    </div>
  );
}

export default VariantCard;